import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/card/lock_white.svg'
import _imports_1 from '@/assets/images/pictures/qr_image.png'
import _imports_2 from '@/assets/images/icons/lock_color.png'
import _imports_3 from '@/assets/images/icons/used_mark.png'


const _hoisted_1 = { class: "qr-status-comp" }
const _hoisted_2 = {
  key: 0,
  class: "status-row event-lock"
}
const _hoisted_3 = { class: "title-text mb-16" }
const _hoisted_4 = { class: "desc-text" }
const _hoisted_5 = {
  key: 1,
  class: "status-row event-lock"
}
const _hoisted_6 = { class: "title-text" }
const _hoisted_7 = {
  key: 0,
  class: "desc-text mb-4"
}
const _hoisted_8 = { class: "desc-text" }
const _hoisted_9 = { class: "desc-text" }
const _hoisted_10 = { class: "desc-text" }
const _hoisted_11 = {
  key: 2,
  class: "status-row status-lock"
}
const _hoisted_12 = {
  key: 3,
  class: "status-row event-lock"
}
const _hoisted_13 = { class: "title-text mb-16" }
const _hoisted_14 = { class: "desc-text" }

import { computed } from "vue";
import dayjs from 'dayjs';
import {useI18n} from 'vue-i18n';
import {formatDate} from '@/models/utils/dateUtils';
import MvButton from "@/components/common/button/MvButton.vue";
import {showNtfc} from "@/script/common/popupScript";
import {resendQpassAlimtalkApi} from '@/api/nftApis';


export default /*@__PURE__*/_defineComponent({
  __name: 'QrStatusComp',
  props: {
  nftId: {
    default: 0
  },
  cltnId: {
    default: 0
  },
  status: {
    default: "",
  },
  type: {
    default: "MEMBERSHIP",
  },
  openDate: {
    default: '',
  },
  timeZone: {
    default: '',
  },
  isQpass: {
    default: false
  },
  needSeat: {
    default: false
  },
  seatStartDate: {
    default: null
  },
  attributes: {
    default: {}
  }
},
  setup(__props) {

const props = __props
const { locale } = useI18n()
dayjs.locale(locale.value)
const openDateTxt = computed(() => {
  return formatDate(props.openDate, {
    format: 'lll',
    timeZone: props.timeZone,
  })
})

const resendQpass = async () => {
  await resendQpassAlimtalkApi(props.nftId)
  showNtfc('입장권이 모바일로 재전송되었습니다.')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.isQpass)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("img", {
            src: _imports_0,
            alt: "Lock Image",
            class: "lock-icon mb-8"
          }, null, -1)),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('nftCard.qpass.sent')), 1),
          _createElementVNode("p", _hoisted_4, [
            _createVNode(MvButton, {
              text: _ctx.$t('common.resend'),
              type: "rec-primary",
              onClick: _withModifiers(resendQpass, ["stop"])
            }, null, 8, ["text"])
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "back-image-area" }, [
            _createElementVNode("img", {
              src: _imports_1,
              alt: "QR Image",
              class: "back-image"
            })
          ], -1))
        ]))
      : (__props.needSeat)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("img", {
              src: _imports_0,
              alt: "Lock Image",
              class: "lock-icon mb-8"
            }, null, -1)),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('nftCard.status.seat.required')), 1),
            (__props.seatStartDate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('nftCard.status.seat.time')), 1),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(dayjs)(__props.seatStartDate).format('YYYY-MM-DD HH:mm')), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_10, [
              _createVNode(MvButton, {
                text: _ctx.$t('nftCard.status.seat.submit'),
                type: "rec-primary",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'SeatSelectView', params: {cltnId: __props.cltnId}, query: {date: __props.attributes?.startDate} })), ["stop"]))
              }, null, 8, ["text"])
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "back-image-area" }, [
              _createElementVNode("img", {
                src: _imports_1,
                alt: "QR Image",
                class: "back-image"
              })
            ], -1))
          ]))
        : (__props.status === 'ticketLock')
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _cache[5] || (_cache[5] = _createElementVNode("img", {
                src: _imports_2,
                alt: "Lock Image"
              }, null, -1)),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t("nftCard.status.TICKET.lock")), 1),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "back-image-area" }, [
                _createElementVNode("img", {
                  src: _imports_1,
                  alt: "QR Image",
                  class: "back-image"
                })
              ], -1))
            ]))
          : (__props.status === 'beforeOpen')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _cache[8] || (_cache[8] = _createElementVNode("img", {
                  src: _imports_0,
                  alt: "Lock Image",
                  class: "lock-icon mb-8"
                }, null, -1)),
                _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("nftCard.eventLock.title")), 1),
                _createElementVNode("p", _hoisted_14, [
                  _createTextVNode(_toDisplayString(_ctx.$t("nftCard.eventLock.activeTime")), 1),
                  _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(_toDisplayString(openDateTxt.value), 1)
                ]),
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "back-image-area" }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "QR Image",
                    class: "back-image"
                  })
                ], -1))
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: 4,
                class: _normalizeClass(["status-row status-used", `type-${__props.type}`])
              }, [
                _cache[10] || (_cache[10] = _createElementVNode("img", {
                  src: _imports_3,
                  alt: "Used Image"
                }, null, -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t(`nftCard.status.${__props.type}.${__props.status}`)), 1)
              ], 2))
  ]))
}
}

})